import {Button} from '@mui/material';
import {
  ComponentProps,
  JSXElementConstructor,
  ReactNode,
  useState,
} from 'react';

import {AssetHuman} from '../../interfaces/AssetHuman';
import ModalDraggable from '../common/ModalDraggable';
import AssetHumanItemUpsert from './AssetHumanItemUpsert';

type ComponentType = keyof JSX.IntrinsicElements | JSXElementConstructor<any>;

interface Props<T extends ComponentType> {
  pk?: number;
  item?: AssetHuman;
  mode?: 'view' | 'update' | 'chat';
  prefetch?: boolean;
  component?: T;
  componentProps?: ComponentProps<T>;
  children?: ReactNode;
  onSubmitted?: () => void;
  onPurged?: () => void;
  onOpenHistory?: () => void;
  onOpen?: () => void;
  onClose?: Function;
}

const AssetHumanItemUpsertButton = <T extends ComponentType = typeof Button>({
  pk,
  item,
  mode,
  prefetch,
  component,
  componentProps,
  children,
  onSubmitted,
  onPurged,
  onOpenHistory,
  onOpen,
  onClose,
}: Props<T>) => {
  const Component = component ?? Button;
  const [isOpened, setIsOpened] = useState(false);

  return (
    <>
      <Component
        {...componentProps}
        onClick={() => {
          setIsOpened(true);
          onOpen?.();
        }}
      >
        {children}
      </Component>

      {isOpened ? (
        <ModalDraggable open={isOpened}>
          <AssetHumanItemUpsert
            pk={pk}
            item={item}
            mode={mode}
            prefetch={prefetch}
            onClose={() => {
              setIsOpened(false);
              onClose?.();
            }}
            onSubmitted={() => {
              onSubmitted?.();
              if (!pk) {
                setIsOpened(false);
                onClose?.();
              }
            }}
            onPurged={onPurged}
            onOpenHistory={onOpenHistory}
          />
        </ModalDraggable>
      ) : null}
    </>
  );
};

export default AssetHumanItemUpsertButton;
